// extracted by css-extract-rspack-plugin
export default {"callout":"callout-GvsKC5","icon":"icon-t0bPiU"};